import React from 'react';
import PropTypes from 'prop-types';
// images
import emptyList from 'app/_assets/img/ic_empty_list.png';
// CSS import
import './EmptyList.scss';

const EmptyList = ({ emptyMessage }) => {
    return (
        <div className="empty-list">
            <img src={emptyList} alt={emptyMessage} />
            <div>{emptyMessage}</div>
        </div>
    );
};

EmptyList.propTypes = {
    emptyMessage: PropTypes.string.isRequired,
};

export default EmptyList;
